import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { usePartialState } from '@tencent/dz-models';
import { usePageModel } from '../context';
export var PageRenderer = function (props) {
    var _a = useComponents(), View = _a.View, Text = _a.Text, ScrollView = _a.ScrollView;
    var model = usePageModel();
    var bricks = props.bricks;
    var _b = usePartialState(function () { return model.getMessageModel(); }), msgModel = _b[1];
    // 获取广审号
    var _c = usePartialState(function () { return model.getConsultModel(); }), consultInstance = _c[1];
    var adAuditNum = consultInstance.getConsultConfig().ad_audit_certificate;
    var renderMessage = React.useMemo(function () { return (React.createElement(ScrollView, { style: { paddingBottom: 20 }, className: "content" }, msgModel.messageQueue.map(function (message) { return (React.createElement(View, { style: { paddingLeft: 15, paddingRight: 15, marginTop: 15 }, key: message.msg_id }, Object.values(bricks).map(function (brick) {
        if (brick.msgType === message.type) {
            var Brick = brick;
            return React.createElement(Brick, { type: message.msg_type, messageId: message.msg_id, key: message.msg_id });
        }
    }))); }))); }, [adAuditNum, msgModel.messageQueue]);
    return (React.createElement(View, { style: { backgroundColor: '#f6f8f9', height: '100%' } },
        props.children,
        renderMessage));
};
